"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4429],{

/***/ 863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ hero; }
});

// EXTERNAL MODULE: ../../node_modules/react-markdown/lib/react-markdown.js + 137 modules
var react_markdown = __webpack_require__(843);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/Text/index.tsx




var Text = function Text(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: text.split("\n").map(function (item, index, text) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [item, index !== text.length - 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}) : null]
      }, index);
    })
  });
};
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/index.ts + 7 modules
var analytics = __webpack_require__(8217);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
// EXTERNAL MODULE: ../../libs/utility/src/lib/theme/colors/index.ts
var colors = __webpack_require__(2193);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/hero/index.style.ts


var LandingMapParent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__LandingMapParent",
  componentId: "e82ma-0"
})(["background:", ";"], colors/* BG_COLOR.black */.VR.black);
var LandingMap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__LandingMap",
  componentId: "e82ma-1"
})(["background:#010101;padding-left:120px;padding-right:120px;padding-bottom:125px;padding-top:40px;color:#fff;font-weight:400;font-size:22px;line-height:24px;display:flex;flex-direction:column;align-items:center;"]);
var LandingMapWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__LandingMapWrap",
  componentId: "e82ma-2"
})(["display:flex;align-items:center;justify-content:space-between;width:1200px;margin:0 auto;background-repeat:no-repeat;background-position:top right;background-size:750px 700px;height:600px;*/"]);
var LandingMapScroll = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__LandingMapScroll",
  componentId: "e82ma-3"
})(["width:34px;height:60px;background:", ";border:1px solid ", ";border-radius:33px;padding:10px;position:relative;top:-90px;opacity:0;", ""], colors/* BG_COLOR.vividBlack */.VR.vividBlack, colors/* BORDER_COLOR.dimGrey */.dS.dimGrey, function (props) {
  return props.scroll && "\n opacity:1;\n\t";
});
var ScrollBall = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__ScrollBall",
  componentId: "e82ma-4"
})(["width:12px;height:12px;border-radius:100%;background:", ";animation:bounce 1.5s;animation-iteration-count:infinite;@keyframes bounce{from{transform:translate3d(0,0,0);opacity:1;}to{transform:translate3d(0,26px,0);opacity:0;}}"], colors/* BG_COLOR.white */.VR.white);
var LandingMapLeft = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__LandingMapLeft",
  componentId: "e82ma-5"
})(["display:flex;flex-direction:column;width:607px;z-index:1;margin-top:-55px;img{margin-right:0.75rem;vertical-align:middle;}p{font-size:22px;line-height:32px;margin-bottom:20px;}p em{color:", ";font-weight:700;text-decoration:none;font-style:normal;}h3{font-weight:600;font-size:48px;line-height:36px;color:", ";margin-bottom:16px;margin-top:2.5rem;}h4{font-weight:normal;font-size:22px;}"], colors/* BLUE_COLOR.lightSkyBlue */.vX.lightSkyBlue, colors/* TEXT_COLOR.aquamarine */.ou.aquamarine);
var LandingMapRight = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__LandingMapRight",
  componentId: "e82ma-6"
})(["width:700px;height:700px;background-position:top right;background-repeat:no-repeat;display:flex;align-items:center;justify-content:center;"]);
var LandingMapIndia = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__LandingMapIndia",
  componentId: "e82ma-7"
})(["width:326px;height:357px;flex-shrink:0;"]);
var LandingMapHd = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "indexstyle__LandingMapHd",
  componentId: "e82ma-8"
})(["background:linear-gradient( 91.72deg,", " 0.38%,", " 38.24%,", " 75.95% );-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;text-fill-color:transparent;font-weight:500;font-size:56px;line-height:72px;margin-bottom:16px;font-family:\"Raleway\";"], colors/* GRADIENT_COLOR.lightPink */.oi.lightPink, colors/* GRADIENT_COLOR.snow */.oi.snow, colors/* GRADIENT_COLOR.skyBlue */.oi.skyBlue);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(8529);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(9330);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/FlexComp/FlexComp.tsx + 1 modules
var FlexComp = __webpack_require__(2439);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/TextStyles/H6Tag.tsx
var H6Tag = __webpack_require__(9808);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/TextStyles/SpanTag.tsx
var SpanTag = __webpack_require__(2348);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/TextStyles/TextStyles.style.ts
var TextStyles_style = __webpack_require__(8059);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/MapCompNew/MapCompNew.style.ts


var ripple = (0,styled_components_browser_esm/* keyframes */.F4)(["0%{width:0;height:0;border-width:0;opacity:1;}100%{width:434px;height:434px;opacity:0;border-width:1px;}"]);
var ripple2 = (0,styled_components_browser_esm/* keyframes */.F4)(["0%{width:0;height:0;border-width:0;opacity:1;}100%{width:64px;height:64px;opacity:0;border-width:1px;}"]);
var rippleIcon = (0,styled_components_browser_esm/* keyframes */.F4)(["0%{opacity:0;}2%{opacity:1;}100%{opacity:0;}"]);
var IndiaWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MapCompNewstyle__IndiaWrap",
  componentId: "hvz0zh-0"
})(["width:700px;height:550px;flex-shrink:0;position:relative;top:51px;display:flex;flex-direction:column;align-items:center;img{margin-top:-90px;}"]);
var RippleCompWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MapCompNewstyle__RippleCompWrap",
  componentId: "hvz0zh-1"
})(["position:absolute;top:", ";left:", ";transform:translate(-50%,-50%);display:flex;align-items:center;justify-content:center;width:", ";height:", ";"], function (p) {
  return p.posY ? p.posY : "auto";
}, function (p) {
  return p.posX ? p.posX : "auto";
}, function (p) {
  return p.pointDetailType ? "434px" : "64px";
}, function (p) {
  return p.pointDetailType ? "434px" : "64px";
});
var RippleCompStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MapCompNewstyle__RippleCompStyle",
  componentId: "hvz0zh-2"
})(["width:0;height:0;opacity:0;background:", ";border:1px solid ", ";border-radius:100%;animation:", " 4s ease-in-out;flex-shrink:0;animation-delay:", "s;"], function (p) {
  return p.bgColor ? p.bgColor : "";
}, function (p) {
  return p.borderColor ? p.borderColor : "";
}, function (p) {
  return p.pointDetailType ? ripple : ripple2;
}, function (p) {
  return p.animDelay ? p.animDelay : "";
});
var InnerDot = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MapCompNewstyle__InnerDot",
  componentId: "hvz0zh-3"
})(["width:4px;height:4px;opacity:0;border-radius:100%;background:", ";position:absolute;animation:", " ease-in-out;animation-duration:", "s;animation-delay:", "s;text-align:center;display:flex;flex-direction:center;align-items:center;justify-content:center;gap:10px;svg{position:absolute;top:-23px;left:-10px;}& > ", "{min-width:90px;margin-top:50px;}"], function (p) {
  return p.borderColor ? p.borderColor : "";
}, rippleIcon, function (p) {
  return p.pointDetailType ? 5 : 4;
}, function (p) {
  return p.animDelay ? p.animDelay + 0.7 : "";
}, TextStyles_style/* SpanTagStyle */.zs);
var MapIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MapCompNewstyle__MapIcon",
  componentId: "hvz0zh-4"
})(["margin-top:10px;"]);
// EXTERNAL MODULE: ../../libs/utility/src/index.ts + 8 modules
var src = __webpack_require__(4976);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/MapCompNew/RippleComp.tsx








var RippleComp = function RippleComp(_ref) {
  var posX = _ref.posX,
      posY = _ref.posY,
      pointDetailType = _ref.pointDetailType,
      bgColor = _ref.bgColor,
      borderColor = _ref.borderColor,
      icon = _ref.icon,
      animDelay = _ref.animDelay,
      cityName = _ref.cityName,
      countryName = _ref.countryName;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(RippleCompWrap, {
    posX: posX,
    posY: posY,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RippleCompStyle, {
      animDelay: animDelay,
      pointDetailType: pointDetailType,
      bgColor: bgColor,
      borderColor: borderColor
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InnerDot, {
      animDelay: animDelay,
      borderColor: borderColor,
      pointDetailType: pointDetailType,
      children: [icon, pointDetailType && /*#__PURE__*/(0,jsx_runtime.jsxs)(SpanTag/* default */.Z, {
        color: Global/* theme.whiteText */.rS.whiteText,
        fontSize: "xs",
        children: ["Card swipe in", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(SpanTag/* default */.Z, {
          color: Global/* theme.whiteText */.rS.whiteText,
          fontSize: "xs",
          fontWeight: "semiBold",
          children: [(0,src/* convertToPascalCase */.JA)(cityName), ",", " ", (0,src/* convertToPascalCase */.JA)(countryName)]
        })]
      })]
    })]
  }, +new Date());
};

/* harmony default export */ var MapCompNew_RippleComp = (RippleComp);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/MapComp/hooks/useMapData.tsx + 1 modules
var useMapData = __webpack_require__(9395);
// EXTERNAL MODULE: ../../libs/utility/src/lib/constants/index.ts + 2 modules
var constants = __webpack_require__(9753);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/useInfiniteMapEvents/index.ts
var useInfiniteMapEvents = __webpack_require__(5997);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/MapCompNew/styled.ts

var Legend = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__Legend",
  componentId: "cc2fds-0"
})(["transform:translateX(16px);text-align:center;"]);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/Image/index.tsx + 1 modules
var Image = __webpack_require__(8863);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/MapCompNew/MapCompNew.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















function randomIntFromInterval(min, max) {
  var delay;
  delay = Math.floor(Math.random() * (max - min + 1) + min);
  return delay;
}

var midX = 350;
var midY = 275;

var MapCompNew = function MapCompNew(_ref) {
  var mapData = _ref.mapData;

  var _useMapData = (0,useMapData/* useMapData */.x)(),
      _useMapData2 = (0,slicedToArray/* default */.Z)(_useMapData, 1),
      array = _useMapData2[0];

  var _useInfiniteMapEvents = (0,useInfiniteMapEvents/* default */.Z)(array),
      displayedArray = _useInfiniteMapEvents.displayedArray;

  var pointType = mapData === null || mapData === void 0 ? void 0 : mapData.pointType;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(IndiaWrap, {
    className: "indiaMapWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
      margin: "0 0 35px",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", _objectSpread(_objectSpread({}, mapData === null || mapData === void 0 ? void 0 : mapData.mapImg), {}, {
        alt: "map"
      })), displayedArray && displayedArray.map(function (item, index) {
        var cityName = item.cityName;
        var x;
        var x1;
        var newx;
        var x2;
        var y;
        var y1;
        var newy;
        var y2;
        x2 = constants/* cities */.cA[cityName.toLowerCase()][0] / 1.579 - 100;
        y2 = constants/* cities */.cA[cityName.toLowerCase()][1] / 1.579 - 251;
        x = "".concat(constants/* cities */.cA[cityName.toLowerCase()][0] / 1.579 - 100, "px");
        y = "".concat(constants/* cities */.cA[cityName.toLowerCase()][1] / 1.579 - 251, "px");
        newx = "".concat((x2 + midX) / 2, "px");
        newy = "".concat((y2 + midY) / 2, "px");
        x1 = JSON.stringify(item.event_name) == JSON.stringify(pointType[0]) ? newx : x;
        y1 = JSON.stringify(item.event_name) == JSON.stringify(pointType[0]) ? newy : y;
        return /*#__PURE__*/(0,jsx_runtime.jsx)(MapCompNew_RippleComp, {
          cityName: item.cityName,
          countryName: item.countryName,
          posX: x1,
          posY: y1,
          bgColor: item.event_name.bgColorProp,
          borderColor: item.event_name.borderColorProp,
          icon: item.event_name.icon,
          pointDetailType: JSON.stringify(item.event_name) == JSON.stringify(pointType[0]),
          animDelay: randomIntFromInterval(1, 10)
        }, index);
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Legend, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(H6Tag/* default */.Z, {
        color: Global/* theme.whiteText */.rS.whiteText,
        margin: "0 0 12px",
        children: mapData === null || mapData === void 0 ? void 0 : mapData.mapTitle
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(FlexComp/* default */.Z, {
        gap: "25px",
        alignItems: "center",
        children: pointType && pointType.map(function (item) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
            gap: "6px",
            alignItems: "center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MapIcon, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, {
                src: item.icon,
                height: "24",
                width: "24",
                loading: "eager"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(SpanTag/* default */.Z, {
              color: Global/* theme.greyText8 */.rS.greyText8,
              fontSize: "xs",
              children: item.type
            })]
          }, item.type);
        })
      })]
    })]
  });
};

/* harmony default export */ var MapCompNew_MapCompNew = (MapCompNew);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/useScroll/index.ts
var useScroll = __webpack_require__(3907);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/hero/index.tsx










var Hero = function Hero(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      mapData = _ref.mapData,
      foreignCurrencyCTALinkEvent = _ref.foreignCurrencyCTALinkEvent,
      forexCardsCTALinkEvent = _ref.forexCardsCTALinkEvent,
      travelLoanCTALinkEvent = _ref.travelLoanCTALinkEvent,
      travelInsuranceCTALinkEvent = _ref.travelInsuranceCTALinkEvent;
  var router = (0,next_router.useRouter)();

  var _useScroll = (0,useScroll/* useScroll */.v)(),
      scroll = _useScroll.scroll;

  var handleLinkClick = function handleLinkClick(props) {
    if ((props === null || props === void 0 ? void 0 : props.title) === "forex-currency") {
      (0,analytics/* pushEvent */.AB)(foreignCurrencyCTALinkEvent);
    } else if ((props === null || props === void 0 ? void 0 : props.title) === "forex-card") {
      (0,analytics/* pushEvent */.AB)(forexCardsCTALinkEvent);
    } else if ((props === null || props === void 0 ? void 0 : props.title) === "travel-insurance") {
      (0,analytics/* pushEvent */.AB)(travelInsuranceCTALinkEvent);
    } else if ((props === null || props === void 0 ? void 0 : props.title) === "travel-credit-line") {
      (0,analytics/* pushEvent */.AB)(travelLoanCTALinkEvent);
    }

    router.push(props === null || props === void 0 ? void 0 : props.href);
  };

  var renderers = {
    a: function a(props) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        onClick: function onClick() {
          return handleLinkClick(props);
        },
        children: props.children
      });
    }
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingMap, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LandingMapWrap, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LandingMapLeft, {
        id: "LandingMapLeft",
        children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingMapHd, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text, {
            text: title
          })
        }), subTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
          components: renderers,
          children: subTitle
        })]
      }), mapData && /*#__PURE__*/(0,jsx_runtime.jsx)(MapCompNew_MapCompNew, {
        mapData: mapData
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingMapScroll, {
      scroll: scroll,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ScrollBall, {})
    })]
  });
};

/* harmony default export */ var hero = (Hero);

/***/ })

}]);